var angular = require('angular');
var _module = angular.module('benoit');
var config = require('config');

require('raygun4js');

_module.run(function onAppRun() {
    // Raygun
    window.Raygun.init(config.raygun.apiKey).attach();
    window.Raygun.withTags([config.name]);
    window.Raygun.setVersion('__GIT_MY_VERSION__');
});

_module.config([
    '$provide',

    function ($provide) {
        $provide.decorator('$exceptionHandler', [
            '$delegate',

            function ($delegate) {
                return function (exception, cause) {
                    window.Raygun.send(exception);
                    $delegate(exception, cause);
                };
            }
        ]);
    }
]);

_module.service('$raygun', [
    function raygunService() {
        return window.Raygun;
    }
]);
